import type {
  DeviceType,
  Dimension,
  Modification,
  Tab,
} from '@carboncopyco/types';
import constate from 'constate';
import type { FunctionComponent, PropsWithChildren, ReactElement } from 'react';
import type {
  UseNavigate,
  WorkspaceSelectionField,
} from '../../types/dependencies';

export type TourCapturePageProps = {
  useNavigate: UseNavigate;
  dynamicRecordingUrl: string;
  fileServiceDynamicLink: string;
  WorkspaceSelectionField: WorkspaceSelectionField;
  uuid: string;
  mimesisReplicateUrl?: string;
  webViewFrame?: ReactElement;
  onModalClosed?: () => void;
  desktopHooks?: {
    useFocusModalAppService: (isOpen: boolean) => void;
    useTabManager: () => {
      closeGlobalActiveTab: () => void;
    };
  };
  tab?: Tab;
  activeTabId?: number;
  onDimensionChange?: (
    dimension: Dimension,
    type: DeviceType,
    fitFactor: number
  ) => void;
  desktopNavigate?: {
    goBack: () => void;
    goForward: () => void;
    canGoBack: boolean;
    canGoForward: boolean;
  };
  onStartCapturing?: () => void;
  onRestartCapturing?: () => void;
  onModificationsReady?: (modifications: Modification<any>[]) => void;
};

export const [TourCapturePageProvider, useTourCapturePageProps]: [
  FunctionComponent<PropsWithChildren<TourCapturePageProps>>,
  () => TourCapturePageProps,
] = constate((props: TourCapturePageProps) => props);
